import React, { useState, useEffect } from 'react';
import {
    TextInput,
    AutocompleteInput,
    NumberInput,
    SelectInput,
    required,
    Toolbar,
    SaveButton
} from 'react-admin';
import { FormTab, TabbedForm } from "ra-ui-materialui";
import { Button } from '@material-ui/core';

// Reutilizamos tu lógica de master-tables
import { getActivityType } from "../../services/master-tables.service";

// Importamos tus componentes originales de activities.js
import {
    ActivityTypeValueInput,
    ContractProfessionalsInput,
    ContractParticipantsInput,
    ContractsInput
} from "../../resources/activities";
import { TabsUseStyles } from "../../App"; // Importamos los estilos de las pestañas que ya usas
import professionalProvider from "../../provider/professional.provider";


const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const dayChoices = days.map((name, id) => ({ id, name }));
const timeFormat = value => {
    if (!value) return 'Requerido';
    return /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value) ? undefined : 'Formato incorrecto';
};
const positiveDuration = value => {
    if (value === undefined || value === null || value === '') return 'Requerido';
    return Number(value) > 0 ? undefined : 'Tiene que ser mayor que 0';
};
const openTimePicker = event => {
    if (typeof event?.target?.showPicker === 'function') {
        event.target.showPicker();
    }
};

// Creamos una barra inferior personalizada para alojar "Cancelar" y "Confirmar"
const ActivityPlannedToolbar = ({ onCancel, ...props }) => (
    <Toolbar {...props} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Button variant="outlined" color="secondary" onClick={onCancel}>
            Cancelar
        </Button>
        {/* SaveButton ya engancha automáticamente con el onSubmit del TabbedForm */}
        <SaveButton label="Confirmar Cambios" />
    </Toolbar>
);

const ActivityPlanned = ({ editingActivity, setEditingActivity, onSave, professionalTypes, identity }) => {


    const [activityType, setactivityType] = useState();

    // Aplicamos las clases de tu diseño original
    const classes = TabsUseStyles();

    useEffect(() => {

        getActivityType().then(res => setactivityType(res?.elements));
    }, []);

    // Transformar el editingActivity del Mock a la estructura que espera el formulario
    const formRecord = {
        ...editingActivity,
        professional: { id: editingActivity.professionalId }, // Formato anidado para el select
    };

    const handleSubmit = async (values) => {
        const professionalId = values.professional?.id;
        let professionalName = values.professionalName;

        if (professionalId && professionalId !== editingActivity.professionalId) {
            const professionalResponse = await professionalProvider.getOne(null, { id: professionalId });
            const professional = professionalResponse?.data;
            professionalName = `${professional?.name || ''} ${professional?.surnames || ''}`.trim();
        }

        // Al guardar, devolvemos a la estructura plana que espera la tabla
        const updatedRecord = {
            ...values,
            professionalId,
            professionalName,
        };
        onSave(updatedRecord);
    };

    return (
        <div style={{ marginTop: '1rem' }}>
            <TabbedForm
                record={formRecord}
                save={handleSubmit}
                classes={classes}
                toolbar={<ActivityPlannedToolbar onCancel={() => setEditingActivity(null)} />}
            >
                {/* PESTAÑA 1: ACTIVIDAD */}
                <FormTab label="Actividad" contentClassName="tab-container">
                    <TextInput label="Nombre Actividad" source="name" validate={[required()]} fullWidth />
                    <TextInput label="Descripción" source="description" multiline validate={[required()]} fullWidth />

                    {/* Fíjate que el source="professional.id" enlaza perfecto con la estructura anidada */}
                    <ContractProfessionalsInput professionalTypes={professionalTypes} source="professional.id" disabled={false} />

                    {activityType && (
                        <AutocompleteInput
                            label="Tipología dinámica"
                            source="primaryTypeId"
                            choices={activityType}
                            optionText="value"
                            optionValue="id"
                            resettable
                            validate={[required()]}
                            fullWidth
                        />
                    )}

                    {/* El mode="create" quita los bloqueos de lectura en Base de datos */}
                    <ActivityTypeValueInput source="typeValue" mode="edit" />
                </FormTab>

                {/* PESTAÑA 2: CONTRATOS */}
                <FormTab label="Contratos">
                    <ContractsInput source="id" mode="create" />
                    <TextInput style={{ display: 'none' }} source="contractsValidation" />
                </FormTab>

                {/* PESTAÑA 3: PARTICIPANTES */}
                <FormTab label="Participantes">
                    <ContractParticipantsInput source="id" mode="create" />
                    <TextInput style={{ display: 'none' }} source="participantsValidation" />
                </FormTab>

                <FormTab label="Agenda" contentClassName="tab-container">
                    <SelectInput
                        label="Día Habitual"
                        source="day"
                        choices={dayChoices}
                        optionText="name"
                        optionValue="id"
                        validate={[required()]}
                        fullWidth
                    />
                    <TextInput
                        label="Hora Habitual"
                        source="startTime"
                        type="time"
                        validate={[timeFormat]}
                        onClick={openTimePicker}
                        onFocus={openTimePicker}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 300 }}
                        fullWidth
                    />
                    <NumberInput
                        label="Duración"
                        source="duration"
                        validate={[positiveDuration]}
                        fullWidth
                    />
                </FormTab>

            </TabbedForm>
        </div>
    );
};

export default ActivityPlanned;
